import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";

import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page5RA1.webp";
import Carousel1Image2 from "../assets/Page5RA2.webp";
import Carousel1Image3 from "../assets/Page5RA3.webp";
import LA from "../assets/Page5L.webp";
//@ts-ignore
import LB from "../assets/Page5RB.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2, Carousel1Image3];

const Page5 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* 1st Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  height: {
                    xs: "45vh",
                    sm: "100%",
                  },
                  borderRadius: { xs: "16px", sm: "0vh" },
                  borderTop: {
                    xs: "1vh solid #fff",
                    sm: "none",
                  },
                  borderLeft: {
                    xs: "1vh solid #fff",
                    sm: "none",
                  },
                  borderRight: {
                    xs: "1vh solid #fff",
                    sm: ".5vh solid #fff",
                  },
                  backgroundImage: `url('${LA}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            </Grid>
          </Grid>
          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: {
                      xs: "45vh",
                      sm: "100%",
                    },
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel1Images} />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: { sm: "100%" },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      display: "flex",
                      pb: { xs: 1.5 },
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,
                        textAlign: "justify",
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                          lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },

                          px: { xs: "2vh", sm: "2vw" },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: {
                            xs: "1.7vh",
                            sm: "1vh",
                          },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.65vh",
                            md: "1.5vh",
                            lg: "1.8vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2.2vh",
                            md: "1.2vh",
                            lg: "0vh",
                          },
                          px: { xs: "1.5vh", sm: "2vw" },
                        },
                      }}
                    >
                      This rooftop patio offers an expansive 300 sq. ft. of
                      private outdoor space, perfect for hosting gatherings or
                      enjoying quiet evenings under the lights. Surrounded by
                      lush greenery, this serene oasis provides a peaceful
                      retreat right in the heart of the city. Whether you're
                      entertaining friends or relaxing with a good book, this
                      rooftop patio is a true extension of your living space,
                      offering versatility and charm in equal measure. The
                      perfect spot to unwind, entertain, and make the most of
                      urban living.
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },

                      height: { xs: "46.5vh", sm: "50vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: { xs: "45vh", sm: "50vh" },
                        objectFit: "cover",
                      }}
                      src={LB}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page5;
